export default "__VITE_PUBLIC_ASSET__a4c0f2d2__"